<script setup lang="ts">
  import ExecutionStatusBadge from '@/shared/Executions/components/ExecutionStatusBadge.vue'
  import { Execution } from '@/shared/Executions/models/Execution'

  const props = defineProps<{
    record: Execution
    index?: number
    selectable?: boolean
    onCellClick?: (record: Execution, e?: Event) => void
  }>()

  function handleClick(e?: Event) {
    if (props.selectable && props.onCellClick) {
      props.onCellClick(props.record, e)
    }
  }
</script>

<template>
  <div :class="{ 'cursor-pointer': selectable }" @click="handleClick">
    <ExecutionStatusBadge
      :execution="record"
      :errors="record.errors"
    />
  </div>
</template>
